export { SimpleSouthKoreaMapChart } from "./SimpleSouthKoreaMapChart";
;
